import { render, staticRenderFns } from "./marketplace.vue?vue&type=template&id=22571bc9&scoped=true"
import script from "./marketplace.vue?vue&type=script&lang=js"
export * from "./marketplace.vue?vue&type=script&lang=js"
import style0 from "./marketplace.vue?vue&type=style&index=0&id=22571bc9&prod&scoped=true&lang=css"
import style1 from "./marketplace.vue?vue&type=style&index=1&id=22571bc9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22571bc9",
  null
  
)

export default component.exports